var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/product-image.j2"] = require( "macros/product-image.j2" );
dependencies["macros/video-tile.j2"] = require( "macros/video-tile.j2" );
dependencies["macros/svg-macros.j2"] = require( "macros/svg-macros.j2" );
dependencies["badges/heart-with-circle.j2"] = require( "badges/heart-with-circle.j2" );
dependencies["core-product-tile-quickshop.j2"] = require( "core-product-tile-quickshop.j2" );
dependencies["core-product-tile-title.j2"] = require( "core-product-tile-title.j2" );
dependencies["core-mto-product-tile-price.j2"] = require( "core-mto-product-tile-price.j2" );
dependencies["core-product-tile-price.j2"] = require( "core-product-tile-price.j2" );
dependencies["core-mto-product-tile-swatch-options.j2"] = require( "core-mto-product-tile-swatch-options.j2" );
dependencies["core-product-tile-swatches.j2"] = require( "core-product-tile-swatches.j2" );
dependencies["macros/display-tile-badges.j2"] = require( "macros/display-tile-badges.j2" );
dependencies["core-product-tile-review-meta.j2"] = require( "core-product-tile-review-meta.j2" );
dependencies["core-product-tile-review.j2"] = require( "core-product-tile-review.j2" );
dependencies["core-product-tile-size.j2"] = require( "core-product-tile-size.j2" );
dependencies["core-product-tile-soldout.j2"] = require( "core-product-tile-soldout.j2" );
dependencies["wishlist-grid-add-to-bag.j2"] = require( "wishlist-grid-add-to-bag.j2" );
dependencies["macros/mto-image.j2"] = require( "macros/mto-image.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/product-tile-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/product-tile-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productUrl")) {
var t_4 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_4);
if(t_1.hasOwnProperty("imageUrl")) {
var t_5 = t_1.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_5);
output += "\n";
env.getTemplate("macros/product-image.j2", false, "core/templates/macros/product-tile-macro.j2", false, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
t_6.getExported(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
if(t_6.hasOwnProperty("productImage")) {
var t_9 = t_6.productImage;
} else {
cb(new Error("cannot import 'productImage'")); return;
}
context.setVariable("productImage", t_9);
output += "\n";
env.getTemplate("macros/video-tile.j2", false, "core/templates/macros/product-tile-macro.j2", false, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
t_10.getExported(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
if(t_10.hasOwnProperty("videoTile")) {
var t_13 = t_10.videoTile;
} else {
cb(new Error("cannot import 'videoTile'")); return;
}
context.setVariable("videoTile", t_13);
output += "\n";
env.getTemplate("macros/svg-macros.j2", false, "core/templates/macros/product-tile-macro.j2", false, function(t_15,t_14) {
if(t_15) { cb(t_15); return; }
t_14.getExported(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
if(t_14.hasOwnProperty("linkedSvg")) {
var t_17 = t_14.linkedSvg;
} else {
cb(new Error("cannot import 'linkedSvg'")); return;
}
context.setVariable("linkedSvg", t_17);
var macro_t_18 = runtime.makeMacro(
["tile", "colorCode", "imageId", "altImageId"], 
["tileTemplate", "isAddToCart", "isOwner", "displayOverlayControls", "productIndex", "overrideUrl", "shoppable", "analytics", "attributes", "displayVideo", "displayFavorites", "analyticsQuickShop", "lazy", "imagePreset"], 
function (l_tile, l_colorCode, l_imageId, l_altImageId, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("tile", l_tile);
frame.set("colorCode", l_colorCode);
frame.set("imageId", l_imageId);
frame.set("altImageId", l_altImageId);
frame.set("tileTemplate", kwargs.hasOwnProperty("tileTemplate") ? kwargs["tileTemplate"] : "DEFAULT");
frame.set("isAddToCart", kwargs.hasOwnProperty("isAddToCart") ? kwargs["isAddToCart"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("isOwner", kwargs.hasOwnProperty("isOwner") ? kwargs["isOwner"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("displayOverlayControls", kwargs.hasOwnProperty("displayOverlayControls") ? kwargs["displayOverlayControls"] : runtime.contextOrFrameLookup(context, frame, "True"));
frame.set("productIndex", kwargs.hasOwnProperty("productIndex") ? kwargs["productIndex"] : 0);
frame.set("overrideUrl", kwargs.hasOwnProperty("overrideUrl") ? kwargs["overrideUrl"] : "");
frame.set("shoppable", kwargs.hasOwnProperty("shoppable") ? kwargs["shoppable"] : runtime.contextOrFrameLookup(context, frame, "True"));
frame.set("analytics", kwargs.hasOwnProperty("analytics") ? kwargs["analytics"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("attributes", kwargs.hasOwnProperty("attributes") ? kwargs["attributes"] : []);
frame.set("displayVideo", kwargs.hasOwnProperty("displayVideo") ? kwargs["displayVideo"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("displayFavorites", kwargs.hasOwnProperty("displayFavorites") ? kwargs["displayFavorites"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("analyticsQuickShop", kwargs.hasOwnProperty("analyticsQuickShop") ? kwargs["analyticsQuickShop"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("lazy", kwargs.hasOwnProperty("lazy") ? kwargs["lazy"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("imagePreset", kwargs.hasOwnProperty("imagePreset") ? kwargs["imagePreset"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_19 = "";if(runtime.memberLookup((l_tile),"product") && runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"configurationEnabled")) {
var t_20;
t_20 = true;
frame.set("configurationEnabled", t_20, true);
if(frame.topLevel) {
context.setVariable("configurationEnabled", t_20);
}
if(frame.topLevel) {
context.addExport("configurationEnabled", t_20);
}
;
}
else {
var t_21;
t_21 = false;
frame.set("configurationEnabled", t_21, true);
if(frame.topLevel) {
context.setVariable("configurationEnabled", t_21);
}
if(frame.topLevel) {
context.addExport("configurationEnabled", t_21);
}
;
}
t_19 += "\n    ";
var t_22;
t_22 = false;
frame.set("displayReviews", t_22, true);
if(frame.topLevel) {
context.setVariable("displayReviews", t_22);
}
if(frame.topLevel) {
context.addExport("displayReviews", t_22);
}
t_19 += "\n    ";
var t_23;
t_23 = false;
frame.set("displayLikes", t_23, true);
if(frame.topLevel) {
context.setVariable("displayLikes", t_23);
}
if(frame.topLevel) {
context.addExport("displayLikes", t_23);
}
t_19 += "\n\n    ";
t_19 += "\n    ";
var t_24;
t_24 = true;
frame.set("displaySwatches", t_24, true);
if(frame.topLevel) {
context.setVariable("displaySwatches", t_24);
}
if(frame.topLevel) {
context.addExport("displaySwatches", t_24);
}
t_19 += "\n    ";
var t_25;
t_25 = true;
frame.set("displayBadges", t_25, true);
if(frame.topLevel) {
context.setVariable("displayBadges", t_25);
}
if(frame.topLevel) {
context.addExport("displayBadges", t_25);
}
t_19 += "\n    ";
var t_26;
t_26 = true;
frame.set("displayPrice", t_26, true);
if(frame.topLevel) {
context.setVariable("displayPrice", t_26);
}
if(frame.topLevel) {
context.addExport("displayPrice", t_26);
}
t_19 += "\n    ";
var t_27;
t_27 = false;
frame.set("displaySize", t_27, true);
if(frame.topLevel) {
context.setVariable("displaySize", t_27);
}
if(frame.topLevel) {
context.addExport("displaySize", t_27);
}
t_19 += "\n    ";
var t_28;
t_28 = true;
frame.set("displayTitle", t_28, true);
if(frame.topLevel) {
context.setVariable("displayTitle", t_28);
}
if(frame.topLevel) {
context.addExport("displayTitle", t_28);
}
t_19 += "\n\n    ";
t_19 += "\n    ";
var t_29;
t_29 = false;
frame.set("useMtoPricingDisplay", t_29, true);
if(frame.topLevel) {
context.setVariable("useMtoPricingDisplay", t_29);
}
if(frame.topLevel) {
context.addExport("useMtoPricingDisplay", t_29);
}
t_19 += "\n    ";
var t_30;
t_30 = false;
frame.set("showMoreOptionsLink", t_30, true);
if(frame.topLevel) {
context.setVariable("showMoreOptionsLink", t_30);
}
if(frame.topLevel) {
context.addExport("showMoreOptionsLink", t_30);
}
t_19 += "\n\n    ";
var t_31;
t_31 = runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"visualBadge");
frame.set("visualBadge", t_31, true);
if(frame.topLevel) {
context.setVariable("visualBadge", t_31);
}
if(frame.topLevel) {
context.addExport("visualBadge", t_31);
}
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") == "TITLE_AND_PRICE") {
t_19 += "\n\n        ";
var t_32;
t_32 = false;
frame.set("displaySwatches", t_32, true);
if(frame.topLevel) {
context.setVariable("displaySwatches", t_32);
}
if(frame.topLevel) {
context.addExport("displaySwatches", t_32);
}
t_19 += "\n        ";
var t_33;
t_33 = false;
frame.set("displayBadges", t_33, true);
if(frame.topLevel) {
context.setVariable("displayBadges", t_33);
}
if(frame.topLevel) {
context.addExport("displayBadges", t_33);
}
if(runtime.contextOrFrameLookup(context, frame, "configurationEnabled")) {
t_19 += "\n            ";
var t_34;
t_34 = true;
frame.set("useMtoPricingDisplay", t_34, true);
if(frame.topLevel) {
context.setVariable("useMtoPricingDisplay", t_34);
}
if(frame.topLevel) {
context.addExport("useMtoPricingDisplay", t_34);
}
t_19 += "\n        ";
;
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") == "TITLE_ONLY") {
t_19 += "\n\n        ";
var t_35;
t_35 = false;
frame.set("displayPrice", t_35, true);
if(frame.topLevel) {
context.setVariable("displayPrice", t_35);
}
if(frame.topLevel) {
context.addExport("displayPrice", t_35);
}
t_19 += "\n        ";
var t_36;
t_36 = false;
frame.set("displaySwatches", t_36, true);
if(frame.topLevel) {
context.setVariable("displaySwatches", t_36);
}
if(frame.topLevel) {
context.addExport("displaySwatches", t_36);
}
t_19 += "\n        ";
var t_37;
t_37 = false;
frame.set("displayBadges", t_37, true);
if(frame.topLevel) {
context.setVariable("displayBadges", t_37);
}
if(frame.topLevel) {
context.addExport("displayBadges", t_37);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") == "PRICE_ONLY") {
t_19 += "\n\n        ";
var t_38;
t_38 = false;
frame.set("displaySwatches", t_38, true);
if(frame.topLevel) {
context.setVariable("displaySwatches", t_38);
}
if(frame.topLevel) {
context.addExport("displaySwatches", t_38);
}
t_19 += "\n        ";
var t_39;
t_39 = false;
frame.set("displayBadges", t_39, true);
if(frame.topLevel) {
context.setVariable("displayBadges", t_39);
}
if(frame.topLevel) {
context.addExport("displayBadges", t_39);
}
t_19 += "\n        ";
var t_40;
t_40 = false;
frame.set("displayTitle", t_40, true);
if(frame.topLevel) {
context.setVariable("displayTitle", t_40);
}
if(frame.topLevel) {
context.addExport("displayTitle", t_40);
}
t_19 += "\n\n    ";
t_19 += "\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") == "SKU_SPECIFIC") {
t_19 += "\n\n        ";
var t_41;
t_41 = false;
frame.set("displayBadges", t_41, true);
if(frame.topLevel) {
context.setVariable("displayBadges", t_41);
}
if(frame.topLevel) {
context.addExport("displayBadges", t_41);
}
if(runtime.contextOrFrameLookup(context, frame, "configurationEnabled")) {
t_19 += "\n            ";
var t_42;
t_42 = false;
frame.set("displaySwatches", t_42, true);
if(frame.topLevel) {
context.setVariable("displaySwatches", t_42);
}
if(frame.topLevel) {
context.addExport("displaySwatches", t_42);
}
t_19 += "\n        ";
;
}
else {
var t_43;
t_43 = true;
frame.set("displaySize", t_43, true);
if(frame.topLevel) {
context.setVariable("displaySize", t_43);
}
if(frame.topLevel) {
context.addExport("displaySize", t_43);
}
t_19 += "\n        ";
;
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") == "TITLE_PRICE_NUM_COLORS") {
t_19 += "\n\n        ";
var t_44;
t_44 = true;
frame.set("displayBadges", t_44, true);
if(frame.topLevel) {
context.setVariable("displayBadges", t_44);
}
if(frame.topLevel) {
context.addExport("displayBadges", t_44);
}
if(runtime.contextOrFrameLookup(context, frame, "configurationEnabled")) {
t_19 += "\n            ";
var t_45;
t_45 = true;
frame.set("useMtoPricingDisplay", t_45, true);
if(frame.topLevel) {
context.setVariable("useMtoPricingDisplay", t_45);
}
if(frame.topLevel) {
context.addExport("useMtoPricingDisplay", t_45);
}
t_19 += "\n            ";
var t_46;
t_46 = true;
frame.set("showMoreOptionsLink", t_46, true);
if(frame.topLevel) {
context.setVariable("showMoreOptionsLink", t_46);
}
if(frame.topLevel) {
context.addExport("showMoreOptionsLink", t_46);
}
t_19 += "\n        ";
;
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") != "NO_DETAILS" && runtime.contextOrFrameLookup(context, frame, "configurationEnabled")) {
t_19 += "\n\n        ";
var t_47;
t_47 = true;
frame.set("useMtoPricingDisplay", t_47, true);
if(frame.topLevel) {
context.setVariable("useMtoPricingDisplay", t_47);
}
if(frame.topLevel) {
context.addExport("useMtoPricingDisplay", t_47);
}
t_19 += "\n        ";
var t_48;
t_48 = true;
frame.set("showMoreOptionsLink", t_48, true);
if(frame.topLevel) {
context.setVariable("showMoreOptionsLink", t_48);
}
if(frame.topLevel) {
context.addExport("showMoreOptionsLink", t_48);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") == "NO_DETAILS") {
t_19 += "\n\n        ";
var t_49;
t_49 = false;
frame.set("displaySwatches", t_49, true);
if(frame.topLevel) {
context.setVariable("displaySwatches", t_49);
}
if(frame.topLevel) {
context.addExport("displaySwatches", t_49);
}
t_19 += "\n        ";
var t_50;
t_50 = false;
frame.set("displayBadges", t_50, true);
if(frame.topLevel) {
context.setVariable("displayBadges", t_50);
}
if(frame.topLevel) {
context.addExport("displayBadges", t_50);
}
t_19 += "\n        ";
var t_51;
t_51 = false;
frame.set("displayPrice", t_51, true);
if(frame.topLevel) {
context.setVariable("displayPrice", t_51);
}
if(frame.topLevel) {
context.addExport("displayPrice", t_51);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") == "REGULAR") {
if(runtime.contextOrFrameLookup(context, frame, "visualBadge") == "displaySoldOut") {
t_19 += "\n            ";
var t_52;
t_52 = false;
frame.set("displaySwatches", t_52, true);
if(frame.topLevel) {
context.setVariable("displaySwatches", t_52);
}
if(frame.topLevel) {
context.addExport("displaySwatches", t_52);
}
t_19 += "\n        ";
;
}
t_19 += "\n\n    ";
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
t_19 += runtime.suppressValue((lineno = 117, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_displayTile"), "_displayTile", context, [l_tile,l_colorCode,l_imageId,l_altImageId,runtime.contextOrFrameLookup(context, frame, "tileTemplate"),runtime.contextOrFrameLookup(context, frame, "isAddToCart"),runtime.contextOrFrameLookup(context, frame, "isOwner"),runtime.makeKeywordArgs({"displayVideo": runtime.contextOrFrameLookup(context, frame, "displayVideo"),"displayOverlayControls": runtime.contextOrFrameLookup(context, frame, "displayOverlayControls"),"productIndex": runtime.contextOrFrameLookup(context, frame, "productIndex"),"overrideUrl": runtime.contextOrFrameLookup(context, frame, "overrideUrl"),"shoppable": runtime.contextOrFrameLookup(context, frame, "shoppable"),"analytics": runtime.contextOrFrameLookup(context, frame, "analytics"),"attributes": runtime.contextOrFrameLookup(context, frame, "attributes"),"analyticsQuickShop": runtime.contextOrFrameLookup(context, frame, "analyticsQuickShop"),"lazy": runtime.contextOrFrameLookup(context, frame, "lazy"),"displayReviews": runtime.contextOrFrameLookup(context, frame, "displayReviews"),"displayLikes": runtime.contextOrFrameLookup(context, frame, "displayLikes"),"displaySwatches": runtime.contextOrFrameLookup(context, frame, "displaySwatches"),"displayBadges": runtime.contextOrFrameLookup(context, frame, "displayBadges"),"displayTitle": runtime.contextOrFrameLookup(context, frame, "displayTitle"),"displayPrice": runtime.contextOrFrameLookup(context, frame, "displayPrice"),"displaySize": runtime.contextOrFrameLookup(context, frame, "displaySize"),"displayFavorites": runtime.contextOrFrameLookup(context, frame, "displayFavorites"),"configurationEnabled": runtime.contextOrFrameLookup(context, frame, "configurationEnabled"),"useMtoPricingDisplay": runtime.contextOrFrameLookup(context, frame, "useMtoPricingDisplay"),"showMoreOptionsLink": runtime.contextOrFrameLookup(context, frame, "showMoreOptionsLink"),"imagePreset": runtime.contextOrFrameLookup(context, frame, "imagePreset")})])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
context.addExport("displayProductTile");
context.setVariable("displayProductTile", macro_t_18);
var macro_t_53 = runtime.makeMacro(
["tile", "colorCode", "imageId", "altImageId", "tileTemplate", "isAddToCart", "isOwner"], 
["displayPrice", "displaySwatches", "displayVideo", "displayBadges", "displayReviews", "displayLikes", "displayFavorites", "displayOverlayControls", "displaySize", "displayTitle", "productIndex", "overrideUrl", "shoppable", "analytics", "attributes", "analyticsQuickShop", "lazy", "configurationEnabled", "useMtoPricingDisplay", "showMoreOptionsLink", "imagePreset"], 
function (l_tile, l_colorCode, l_imageId, l_altImageId, l_tileTemplate, l_isAddToCart, l_isOwner, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("tile", l_tile);
frame.set("colorCode", l_colorCode);
frame.set("imageId", l_imageId);
frame.set("altImageId", l_altImageId);
frame.set("tileTemplate", l_tileTemplate);
frame.set("isAddToCart", l_isAddToCart);
frame.set("isOwner", l_isOwner);
frame.set("displayPrice", kwargs.hasOwnProperty("displayPrice") ? kwargs["displayPrice"] : true);
frame.set("displaySwatches", kwargs.hasOwnProperty("displaySwatches") ? kwargs["displaySwatches"] : true);
frame.set("displayVideo", kwargs.hasOwnProperty("displayVideo") ? kwargs["displayVideo"] : false);
frame.set("displayBadges", kwargs.hasOwnProperty("displayBadges") ? kwargs["displayBadges"] : true);
frame.set("displayReviews", kwargs.hasOwnProperty("displayReviews") ? kwargs["displayReviews"] : false);
frame.set("displayLikes", kwargs.hasOwnProperty("displayLikes") ? kwargs["displayLikes"] : false);
frame.set("displayFavorites", kwargs.hasOwnProperty("displayFavorites") ? kwargs["displayFavorites"] : false);
frame.set("displayOverlayControls", kwargs.hasOwnProperty("displayOverlayControls") ? kwargs["displayOverlayControls"] : true);
frame.set("displaySize", kwargs.hasOwnProperty("displaySize") ? kwargs["displaySize"] : false);
frame.set("displayTitle", kwargs.hasOwnProperty("displayTitle") ? kwargs["displayTitle"] : true);
frame.set("productIndex", kwargs.hasOwnProperty("productIndex") ? kwargs["productIndex"] : 0);
frame.set("overrideUrl", kwargs.hasOwnProperty("overrideUrl") ? kwargs["overrideUrl"] : "");
frame.set("shoppable", kwargs.hasOwnProperty("shoppable") ? kwargs["shoppable"] : true);
frame.set("analytics", kwargs.hasOwnProperty("analytics") ? kwargs["analytics"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("attributes", kwargs.hasOwnProperty("attributes") ? kwargs["attributes"] : []);
frame.set("analyticsQuickShop", kwargs.hasOwnProperty("analyticsQuickShop") ? kwargs["analyticsQuickShop"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("lazy", kwargs.hasOwnProperty("lazy") ? kwargs["lazy"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("configurationEnabled", kwargs.hasOwnProperty("configurationEnabled") ? kwargs["configurationEnabled"] : false);
frame.set("useMtoPricingDisplay", kwargs.hasOwnProperty("useMtoPricingDisplay") ? kwargs["useMtoPricingDisplay"] : false);
frame.set("showMoreOptionsLink", kwargs.hasOwnProperty("showMoreOptionsLink") ? kwargs["showMoreOptionsLink"] : false);
frame.set("imagePreset", kwargs.hasOwnProperty("imagePreset") ? kwargs["imagePreset"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_54 = "";l_tileTemplate = env.getFilter("lower").call(context, l_tileTemplate);
frame.set("tileTemplate", l_tileTemplate, true);
if(frame.topLevel) {
context.setVariable("tileTemplate", l_tileTemplate);
}
if(frame.topLevel) {
context.addExport("tileTemplate", l_tileTemplate);
}
t_54 += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "overrideUrl") != "") {
var t_55;
t_55 = runtime.contextOrFrameLookup(context, frame, "overrideUrl");
frame.set("productLink", t_55, true);
if(frame.topLevel) {
context.setVariable("productLink", t_55);
}
if(frame.topLevel) {
context.addExport("productLink", t_55);
}
;
}
else {
var t_56;
t_56 = (lineno = 159, colno = 33, runtime.callWrap(t_4, "productUrl", context, [runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"productSlug"),runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"queryParams")]));
frame.set("productLink", t_56, true);
if(frame.topLevel) {
context.setVariable("productLink", t_56);
}
if(frame.topLevel) {
context.addExport("productLink", t_56);
}
;
}
t_54 += "<div class=\"dom-product-tile c-product-tile c-product-tile--";
t_54 += runtime.suppressValue(l_tileTemplate, env.opts.autoescape);
t_54 += " c-product-tile js-product-tile\"\n    data-product-slug=\"";
t_54 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"productSlug"), env.opts.autoescape);
t_54 += "\"\n    data-product-name=\"";
t_54 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"displayName"), env.opts.autoescape);
t_54 += "\"\n    data-style-number=\"";
t_54 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"styleNumber"), env.opts.autoescape);
t_54 += "\"\n    data-product-index=\"";
t_54 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productIndex"), env.opts.autoescape);
t_54 += "\"\n    data-qa-tile-type=\"";
t_54 += runtime.suppressValue(l_tileTemplate, env.opts.autoescape);
t_54 += "\"\n    data-qa-product=\"";
t_54 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"displayName"), env.opts.autoescape);
t_54 += "\"\n    ";
if(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"productId")) {
t_54 += "data-dy-product-id=\"";
t_54 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"productId"), env.opts.autoescape);
t_54 += "\"";
;
}
t_54 += ">\n\n    <span itemprop=\"product\" itemscope itemtype=\"//schema.org/Product\">";
if(runtime.contextOrFrameLookup(context, frame, "category") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") == "category") {
t_54 += "<meta itemprop=\"category\" content=\"";
t_54 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"))),"displayName"), env.opts.autoescape);
t_54 += "\" />";
;
}
if(runtime.contextOrFrameLookup(context, frame, "category") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") == "brands") {
t_54 += "<meta itemprop=\"category\" content=\"";
t_54 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"), env.opts.autoescape);
t_54 += "\" />";
;
}
t_54 += "<meta itemprop=\"productID\" content=\"";
t_54 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"styleNumber"), env.opts.autoescape);
t_54 += "\" />\n        <meta itemprop=\"url\" content=\"";
t_54 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + (lineno = 179, colno = 82, runtime.callWrap(t_4, "productUrl", context, [runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"productSlug")])))), env.opts.autoescape);
t_54 += "\" />\n\n        ";
var t_57;
t_57 = runtime.memberLookup((l_tile),"product");
frame.set("tileProduct", t_57, true);
if(frame.topLevel) {
context.setVariable("tileProduct", t_57);
}
if(frame.topLevel) {
context.addExport("tileProduct", t_57);
}
t_54 += "\n        ";
var t_58;
t_58 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tileProduct")),"description")?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tileProduct")),"description"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tileProduct")),"displayName"));
frame.set("productTileName", t_58, true);
if(frame.topLevel) {
context.setVariable("productTileName", t_58);
}
if(frame.topLevel) {
context.addExport("productTileName", t_58);
}
t_54 += "\n        <meta itemprop=\"name\" content=\"";
t_54 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productTileName"), env.opts.autoescape);
t_54 += "\" />\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "wishlist") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "wishlist")),"search")) {
t_54 += "<div class=\"c-product-tile-controls__link-wrap js-product-tile-controls__link-wrap--wishlist\">";
;
}
else {
var t_59;
t_59 = (runtime.memberLookup((l_tile),"hasTileVideo")?"js-product-tile-video-wrap":"");
frame.set("videoWrapClass", t_59, true);
if(frame.topLevel) {
context.setVariable("videoWrapClass", t_59);
}
if(frame.topLevel) {
context.addExport("videoWrapClass", t_59);
}
t_54 += "\n            <div class=\"c-product-tile-controls__link-wrap js-product-tile-controls__link-wrap ";
t_54 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "videoWrapClass"), env.opts.autoescape);
t_54 += "\" data-qa-product-tile-controls>";
;
}
var t_60;
t_60 = runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"visualBadge");
frame.set("visualBadge", t_60, true);
if(frame.topLevel) {
context.setVariable("visualBadge", t_60);
}
if(frame.topLevel) {
context.addExport("visualBadge", t_60);
}
if(runtime.contextOrFrameLookup(context, frame, "visualBadge") == "displaySoldOut") {
t_54 += "<div class=\"c-product-tile-sold-out\">\n\n                <p class=\"c-product-tile-sold-out__p\">";
t_54 += runtime.suppressValue((lineno = 201, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-sold-out"])), env.opts.autoescape);
t_54 += "</p>\n\n            </div>";
;
}
var t_61;
t_61 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("_defaultImage", t_61, true);
if(frame.topLevel) {
context.setVariable("_defaultImage", t_61);
}
t_54 += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"isImageMissing")) {
if(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"defaultImage")) {
var t_62;
t_62 = runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"defaultImage");
frame.set("_defaultImage", t_62, true);
if(frame.topLevel) {
context.setVariable("_defaultImage", t_62);
}
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
var t_63;
t_63 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty")),"default")),"scene7")),"tile_placeholder_image_small");
frame.set("_defaultImage", t_63, true);
if(frame.topLevel) {
context.setVariable("_defaultImage", t_63);
}
;
}
else {
var t_64;
t_64 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty")),"default")),"scene7")),"tile_placeholder_image_large");
frame.set("_defaultImage", t_64, true);
if(frame.topLevel) {
context.setVariable("_defaultImage", t_64);
}
;
}
;
}
;
}
if(runtime.contextOrFrameLookup(context, frame, "shoppable")) {
t_54 += "<a href=\"";
t_54 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productLink"), env.opts.autoescape);
t_54 += "\" class=\"c-product-tile__image-link js-product-tile__image-link\" data-product-slug=\"";
t_54 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"productSlug"), env.opts.autoescape);
t_54 += "\" data-qa-product-tile ";
t_54 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "analytics"), env.opts.autoescape);
frame = frame.push();
var t_67 = runtime.contextOrFrameLookup(context, frame, "attributes");
if(t_67) {var t_66 = t_67.length;
for(var t_65=0; t_65 < t_67.length; t_65++) {
var t_68 = t_67[t_65];
frame.set("attr", t_68);
frame.set("loop.index", t_65 + 1);
frame.set("loop.index0", t_65);
frame.set("loop.revindex", t_66 - t_65);
frame.set("loop.revindex0", t_66 - t_65 - 1);
frame.set("loop.first", t_65 === 0);
frame.set("loop.last", t_65 === t_66 - 1);
frame.set("loop.length", t_66);
t_54 += runtime.suppressValue(t_68, env.opts.autoescape);
t_54 += " ";
;
}
}
frame = frame.pop();
t_54 += "data-qa-product-link>";
;
}
if(runtime.contextOrFrameLookup(context, frame, "displayFavorites") && runtime.memberLookup((l_tile),"favoritable")) {
t_54 += "\n\n                    <span tabindex=\"0\" class=\"c-product-heart c-product-heart__tile js-favorite-toggle ";
if(runtime.memberLookup((l_tile),"favorited")) {
t_54 += "is-favorited";
;
}
t_54 += "\" data-qa-product-heart-icon ";
if(runtime.memberLookup((l_tile),"favorited")) {
t_54 += "data-qa-product-is-hearted";
;
}
t_54 += ">\n\n                        ";
env.getTemplate("badges/heart-with-circle.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_71,t_69) {
if(t_71) { cb(t_71); return; }
t_69.render(context.getVariables(), frame, function(t_72,t_70) {
if(t_72) { cb(t_72); return; }
t_54 += t_70
t_54 += "\n\n                    </span>\n\n                ";
})});
}
if(runtime.contextOrFrameLookup(context, frame, "displayBadges") && runtime.contextOrFrameLookup(context, frame, "visualBadge") && runtime.contextOrFrameLookup(context, frame, "visualBadge") != "displaySoldOut") {
t_54 += "<span class=\"c-product-badge-visual ";
t_54 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "visualBadge"), env.opts.autoescape);
t_54 += "\" data-qa-";
t_54 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "visualBadge"), env.opts.autoescape);
t_54 += ">\n\n                        ";
t_54 += runtime.suppressValue((lineno = 249, colno = 34, runtime.callWrap(t_17, "linkedSvg", context, ["badge-" + "" + runtime.contextOrFrameLookup(context, frame, "visualBadge"),"c-product-badge-visual-svg"])), env.opts.autoescape);
t_54 += "\n\n                    </span>";
;
}
t_54 += runtime.suppressValue((lineno = 255, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_displayTileImage"), "_displayTileImage", context, [l_tile,l_colorCode,l_imageId,l_altImageId,runtime.makeKeywordArgs({"defaultImage": runtime.contextOrFrameLookup(context, frame, "_defaultImage"),"lazy": runtime.contextOrFrameLookup(context, frame, "lazy"),"configurationEnabled": runtime.contextOrFrameLookup(context, frame, "configurationEnabled")})])), env.opts.autoescape);
if(runtime.contextOrFrameLookup(context, frame, "shoppable")) {
t_54 += "</a>";
;
}
if(runtime.contextOrFrameLookup(context, frame, "displayOverlayControls")) {
t_54 += "\n                <div class=\"o-row o-column o-large--12 o-extra-small--3 c-product-tile-controls\" data-qa-product-tile-controls>";
if(!runtime.contextOrFrameLookup(context, frame, "configurationEnabled")) {
env.getTemplate("core-product-tile-quickshop.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_75,t_73) {
if(t_75) { cb(t_75); return; }
t_73.render(context.getVariables(), frame, function(t_76,t_74) {
if(t_76) { cb(t_76); return; }
t_54 += t_74
})});
}
t_54 += "\n\n                </div>";
;
}
t_54 += "</div>";
if(l_tileTemplate != "no_details" && runtime.contextOrFrameLookup(context, frame, "shoppable")) {
t_54 += "<div class=\"c-product-tile-details c-product-tile-details--";
t_54 += runtime.suppressValue(l_tileTemplate, env.opts.autoescape);
t_54 += "\" data-qa-tile-details>\n\n            ";
t_54 += "\n            ";
if(runtime.contextOrFrameLookup(context, frame, "displayTitle") && l_tile) {
env.getTemplate("core-product-tile-title.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_79,t_77) {
if(t_79) { cb(t_79); return; }
t_77.render(context.getVariables(), frame, function(t_80,t_78) {
if(t_80) { cb(t_80); return; }
t_54 += t_78
})});
}
t_54 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "useMtoPricingDisplay")) {
t_54 += "\n\n                ";
var t_81;
t_81 = l_tile;
frame.set("productInfo", t_81, true);
if(frame.topLevel) {
context.setVariable("productInfo", t_81);
}
if(frame.topLevel) {
context.addExport("productInfo", t_81);
}
env.getTemplate("core-mto-product-tile-price.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_84,t_82) {
if(t_84) { cb(t_84); return; }
t_82.render(context.getVariables(), frame, function(t_85,t_83) {
if(t_85) { cb(t_85); return; }
t_54 += t_83
})});
}
else {
env.getTemplate("core-product-tile-price.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_88,t_86) {
if(t_88) { cb(t_88); return; }
t_86.render(context.getVariables(), frame, function(t_89,t_87) {
if(t_89) { cb(t_89); return; }
t_54 += t_87
})});
}
t_54 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "showMoreOptionsLink")) {
env.getTemplate("core-mto-product-tile-swatch-options.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_92,t_90) {
if(t_92) { cb(t_92); return; }
t_90.render(context.getVariables(), frame, function(t_93,t_91) {
if(t_93) { cb(t_93); return; }
t_54 += t_91
})});
}
else {
env.getTemplate("core-product-tile-swatches.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_96,t_94) {
if(t_96) { cb(t_96); return; }
t_94.render(context.getVariables(), frame, function(t_97,t_95) {
if(t_97) { cb(t_97); return; }
t_54 += t_95
})});
}
t_54 += "\n\n            ";
t_54 += "\n\n            ";
env.getTemplate("macros/display-tile-badges.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_100,t_98) {
if(t_100) { cb(t_100); return; }
t_98.render(context.getVariables(), frame, function(t_101,t_99) {
if(t_101) { cb(t_101); return; }
t_54 += t_99
t_54 += "\n            ";
if(runtime.memberLookup((l_tile),"reviews") && runtime.memberLookup((runtime.memberLookup((l_tile),"reviews")),"averageRating") && runtime.memberLookup((runtime.memberLookup((l_tile),"reviews")),"count") && runtime.memberLookup((runtime.memberLookup((l_tile),"reviews")),"count") > 0) {
env.getTemplate("core-product-tile-review-meta.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_104,t_102) {
if(t_104) { cb(t_104); return; }
t_102.render(context.getVariables(), frame, function(t_105,t_103) {
if(t_105) { cb(t_105); return; }
t_54 += t_103
})});
}
t_54 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "displayReviews")) {
env.getTemplate("core-product-tile-review.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_108,t_106) {
if(t_108) { cb(t_108); return; }
t_106.render(context.getVariables(), frame, function(t_109,t_107) {
if(t_109) { cb(t_109); return; }
t_54 += t_107
})});
}
t_54 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "displaySize")) {
env.getTemplate("core-product-tile-size.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_112,t_110) {
if(t_112) { cb(t_112); return; }
t_110.render(context.getVariables(), frame, function(t_113,t_111) {
if(t_113) { cb(t_113); return; }
t_54 += t_111
})});
}
t_54 += "\n\n            ";
t_54 += "\n            ";
t_54 += "\n            ";
t_54 += "\n\n            ";
if(runtime.memberLookup((l_tile),"isSoldOut")) {
env.getTemplate("core-product-tile-soldout.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_116,t_114) {
if(t_116) { cb(t_116); return; }
t_114.render(context.getVariables(), frame, function(t_117,t_115) {
if(t_117) { cb(t_117); return; }
t_54 += t_115
})});
}
t_54 += "\n\n            ";
if(l_isAddToCart) {
env.getTemplate("wishlist-grid-add-to-bag.j2", false, "core/templates/macros/product-tile-macro.j2", null, function(t_120,t_118) {
if(t_120) { cb(t_120); return; }
t_118.render(context.getVariables(), frame, function(t_121,t_119) {
if(t_121) { cb(t_121); return; }
t_54 += t_119
})});
}
t_54 += "</div>";
})});
}
t_54 += "</span>\n\n</div>";
;
frame = frame.pop();
return new runtime.SafeString(t_54);
});
context.setVariable("_displayTile", macro_t_53);
var macro_t_122 = runtime.makeMacro(
["tile", "colorCode", "imageId", "altImageId"], 
["defaultImage", "lazy", "configurationEnabled", "imagePreset"], 
function (l_tile, l_colorCode, l_imageId, l_altImageId, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("tile", l_tile);
frame.set("colorCode", l_colorCode);
frame.set("imageId", l_imageId);
frame.set("altImageId", l_altImageId);
frame.set("defaultImage", kwargs.hasOwnProperty("defaultImage") ? kwargs["defaultImage"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("lazy", kwargs.hasOwnProperty("lazy") ? kwargs["lazy"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("configurationEnabled", kwargs.hasOwnProperty("configurationEnabled") ? kwargs["configurationEnabled"] : false);
frame.set("imagePreset", kwargs.hasOwnProperty("imagePreset") ? kwargs["imagePreset"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_123 = "";var t_124;
t_124 = env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_tile),"skuInfo")),"primarySlice")),"sliceItems"),[]);
frame.set("sliceItems", t_124, true);
if(frame.topLevel) {
context.setVariable("sliceItems", t_124);
}
if(frame.topLevel) {
context.addExport("sliceItems", t_124);
}
var t_125;
t_125 = ["",null];
frame.set("defaultImageIds", t_125, true);
if(frame.topLevel) {
context.setVariable("defaultImageIds", t_125);
}
if(frame.topLevel) {
context.addExport("defaultImageIds", t_125);
}
var t_126;
t_126 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sliceItems")),0),{"code": "","images": runtime.contextOrFrameLookup(context, frame, "defaultImageIds")});
frame.set("firstSliceItem", t_126, true);
if(frame.topLevel) {
context.setVariable("firstSliceItem", t_126);
}
if(frame.topLevel) {
context.addExport("firstSliceItem", t_126);
}
var t_127;
t_127 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "firstSliceItem")),"images"),runtime.contextOrFrameLookup(context, frame, "defaultImageIds"));
frame.set("sliceImageIds", t_127, true);
if(frame.topLevel) {
context.setVariable("sliceImageIds", t_127);
}
if(frame.topLevel) {
context.addExport("sliceImageIds", t_127);
}
if((lineno = 385, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_tile,"colors.0.faceOutImage"])) && env.getFilter("length").call(context, (lineno = 385, colno = 90, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_tile),"colors")),0)),"faceOutImage")),"split"), "tile[\"colors\"][\"0\"][\"faceOutImage\"][\"split\"]", context, ["_"]))) > 2) {
var t_128;
t_128 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 386, colno = 61, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_tile),"colors")),0)),"faceOutImage")),"split"), "tile[\"colors\"][\"0\"][\"faceOutImage\"][\"split\"]", context, ["_"]))),1),null);
frame.set("faceOutColor", t_128, true);
if(frame.topLevel) {
context.setVariable("faceOutColor", t_128);
}
if(frame.topLevel) {
context.addExport("faceOutColor", t_128);
}
var t_129;
t_129 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 387, colno = 63, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_tile),"colors")),0)),"faceOutImage")),"split"), "tile[\"colors\"][\"0\"][\"faceOutImage\"][\"split\"]", context, ["_"]))),2),null);
frame.set("faceOutImageId", t_129, true);
if(frame.topLevel) {
context.setVariable("faceOutImageId", t_129);
}
if(frame.topLevel) {
context.addExport("faceOutImageId", t_129);
}
;
}
else {
if(runtime.memberLookup((l_tile),"faceOutImage") && env.getFilter("length").call(context, (lineno = 388, colno = 55, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_tile),"faceOutImage")),"split"), "tile[\"faceOutImage\"][\"split\"]", context, ["_"]))) > 2) {
var t_130;
t_130 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 389, colno = 51, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_tile),"faceOutImage")),"split"), "tile[\"faceOutImage\"][\"split\"]", context, ["_"]))),1),null);
frame.set("faceOutColor", t_130, true);
if(frame.topLevel) {
context.setVariable("faceOutColor", t_130);
}
if(frame.topLevel) {
context.addExport("faceOutColor", t_130);
}
var t_131;
t_131 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 390, colno = 53, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_tile),"faceOutImage")),"split"), "tile[\"faceOutImage\"][\"split\"]", context, ["_"]))),2),null);
frame.set("faceOutImageId", t_131, true);
if(frame.topLevel) {
context.setVariable("faceOutImageId", t_131);
}
if(frame.topLevel) {
context.addExport("faceOutImageId", t_131);
}
;
}
else {
if(runtime.memberLookup((l_tile),"defaultImage") && env.getFilter("length").call(context, (lineno = 391, colno = 55, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_tile),"defaultImage")),"split"), "tile[\"defaultImage\"][\"split\"]", context, ["_"]))) > 2) {
var t_132;
t_132 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 392, colno = 51, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_tile),"defaultImage")),"split"), "tile[\"defaultImage\"][\"split\"]", context, ["_"]))),1),null);
frame.set("faceOutColor", t_132, true);
if(frame.topLevel) {
context.setVariable("faceOutColor", t_132);
}
if(frame.topLevel) {
context.addExport("faceOutColor", t_132);
}
var t_133;
t_133 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 393, colno = 53, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_tile),"defaultImage")),"split"), "tile[\"defaultImage\"][\"split\"]", context, ["_"]))),2),null);
frame.set("faceOutImageId", t_133, true);
if(frame.topLevel) {
context.setVariable("faceOutImageId", t_133);
}
if(frame.topLevel) {
context.addExport("faceOutImageId", t_133);
}
;
}
;
}
;
}
if((lineno = 396, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_tile,"colors.0.hoverImage"])) && env.getFilter("length").call(context, (lineno = 396, colno = 86, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_tile),"colors")),0)),"hoverImage")),"split"), "tile[\"colors\"][\"0\"][\"hoverImage\"][\"split\"]", context, ["_"]))) > 2) {
var t_134;
t_134 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 397, colno = 57, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_tile),"colors")),0)),"hoverImage")),"split"), "tile[\"colors\"][\"0\"][\"hoverImage\"][\"split\"]", context, ["_"]))),1),null);
frame.set("hoverColor", t_134, true);
if(frame.topLevel) {
context.setVariable("hoverColor", t_134);
}
if(frame.topLevel) {
context.addExport("hoverColor", t_134);
}
var t_135;
t_135 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 398, colno = 59, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_tile),"colors")),0)),"hoverImage")),"split"), "tile[\"colors\"][\"0\"][\"hoverImage\"][\"split\"]", context, ["_"]))),2),null);
frame.set("hoverImageId", t_135, true);
if(frame.topLevel) {
context.setVariable("hoverImageId", t_135);
}
if(frame.topLevel) {
context.addExport("hoverImageId", t_135);
}
;
}
else {
if(runtime.memberLookup((l_tile),"hoverImage") && env.getFilter("length").call(context, (lineno = 399, colno = 51, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_tile),"hoverImage")),"split"), "tile[\"hoverImage\"][\"split\"]", context, ["_"]))) > 2) {
var t_136;
t_136 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 400, colno = 47, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_tile),"hoverImage")),"split"), "tile[\"hoverImage\"][\"split\"]", context, ["_"]))),1),null);
frame.set("hoverColor", t_136, true);
if(frame.topLevel) {
context.setVariable("hoverColor", t_136);
}
if(frame.topLevel) {
context.addExport("hoverColor", t_136);
}
var t_137;
t_137 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 401, colno = 49, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_tile),"hoverImage")),"split"), "tile[\"hoverImage\"][\"split\"]", context, ["_"]))),2),null);
frame.set("hoverImageId", t_137, true);
if(frame.topLevel) {
context.setVariable("hoverImageId", t_137);
}
if(frame.topLevel) {
context.addExport("hoverImageId", t_137);
}
;
}
else {
var t_138;
t_138 = env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "faceOutColor"),null);
frame.set("hoverColor", t_138, true);
if(frame.topLevel) {
context.setVariable("hoverColor", t_138);
}
if(frame.topLevel) {
context.addExport("hoverColor", t_138);
}
var t_139;
t_139 = env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "faceOutImageId"),null);
frame.set("hoverImageId", t_139, true);
if(frame.topLevel) {
context.setVariable("hoverImageId", t_139);
}
if(frame.topLevel) {
context.addExport("hoverImageId", t_139);
}
;
}
;
}
if(runtime.contextOrFrameLookup(context, frame, "faceOutImageId")) {
l_imageId = runtime.contextOrFrameLookup(context, frame, "faceOutImageId");
frame.set("imageId", l_imageId, true);
if(frame.topLevel) {
context.setVariable("imageId", l_imageId);
}
if(frame.topLevel) {
context.addExport("imageId", l_imageId);
}
l_colorCode = runtime.contextOrFrameLookup(context, frame, "faceOutColor");
frame.set("colorCode", l_colorCode, true);
if(frame.topLevel) {
context.setVariable("colorCode", l_colorCode);
}
if(frame.topLevel) {
context.addExport("colorCode", l_colorCode);
}
;
}
else {
var t_140;
t_140 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sliceImageIds")),0),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultImageIds")),0));
frame.set("defaultImageId", t_140, true);
if(frame.topLevel) {
context.setVariable("defaultImageId", t_140);
}
if(frame.topLevel) {
context.addExport("defaultImageId", t_140);
}
;
}
if(runtime.contextOrFrameLookup(context, frame, "hoverImageId")) {
l_altImageId = runtime.contextOrFrameLookup(context, frame, "hoverImageId");
frame.set("altImageId", l_altImageId, true);
if(frame.topLevel) {
context.setVariable("altImageId", l_altImageId);
}
if(frame.topLevel) {
context.addExport("altImageId", l_altImageId);
}
;
}
else {
var t_141;
t_141 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sliceImageIds")),1),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultImageIds")),1));
frame.set("defaultAltImageId", t_141, true);
if(frame.topLevel) {
context.setVariable("defaultAltImageId", t_141);
}
if(frame.topLevel) {
context.addExport("defaultAltImageId", t_141);
}
;
}
var t_142;
t_142 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "firstSliceItem")),"code"),"");
frame.set("defaultColorCode", t_142, true);
if(frame.topLevel) {
context.setVariable("defaultColorCode", t_142);
}
if(frame.topLevel) {
context.addExport("defaultColorCode", t_142);
}
t_123 += "\n    ";
var t_143;
t_143 = env.getFilter("default").call(context, l_imageId,runtime.contextOrFrameLookup(context, frame, "defaultImageId"));
frame.set("_imageId", t_143, true);
if(frame.topLevel) {
context.setVariable("_imageId", t_143);
}
t_123 += "\n    ";
var t_144;
t_144 = env.getFilter("default").call(context, l_altImageId,runtime.contextOrFrameLookup(context, frame, "defaultAltImageId"));
frame.set("_altImageId", t_144, true);
if(frame.topLevel) {
context.setVariable("_altImageId", t_144);
}
t_123 += "\n    ";
var t_145;
t_145 = env.getFilter("default").call(context, l_colorCode,runtime.contextOrFrameLookup(context, frame, "defaultColorCode"));
frame.set("_colorCode", t_145, true);
if(frame.topLevel) {
context.setVariable("_colorCode", t_145);
}
t_123 += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "_imageId")) {
var t_146;
t_146 = runtime.contextOrFrameLookup(context, frame, "_imageId");
frame.set("_safeImageId", t_146, true);
if(frame.topLevel) {
context.setVariable("_safeImageId", t_146);
}
;
}
else {
t_123 += "\n        ";
var t_147;
t_147 = "b";
frame.set("_safeImageId", t_147, true);
if(frame.topLevel) {
context.setVariable("_safeImageId", t_147);
}
;
}
if(runtime.contextOrFrameLookup(context, frame, "_colorCode")) {
var t_148;
t_148 = runtime.contextOrFrameLookup(context, frame, "_colorCode");
frame.set("_safeColorCode", t_148, true);
if(frame.topLevel) {
context.setVariable("_safeColorCode", t_148);
}
;
}
else {
var t_149;
t_149 = runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"defaultColorCode");
frame.set("_safeColorCode", t_149, true);
if(frame.topLevel) {
context.setVariable("_safeColorCode", t_149);
}
;
}
var t_150;
t_150 = runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"displayName");
frame.set("altText", t_150, true);
if(frame.topLevel) {
context.setVariable("altText", t_150);
}
if(frame.topLevel) {
context.addExport("altText", t_150);
}
t_123 += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "configurationEnabled")) {
t_123 += "\n        ";
env.getTemplate("macros/mto-image.j2", false, "core/templates/macros/product-tile-macro.j2", false, function(t_152,t_151) {
if(t_152) { cb(t_152); return; }
t_151.getExported(function(t_153,t_151) {
if(t_153) { cb(t_153); return; }
if(t_151.hasOwnProperty("mtoImage")) {
var t_154 = t_151.mtoImage;
} else {
cb(new Error("cannot import 'mtoImage'")); return;
}
frame.set("mtoImage", t_154);
t_123 += "\n\n        ";
var t_155;
t_155 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"mtoTileImagePreset");
frame.set("preset", t_155, true);
if(frame.topLevel) {
context.setVariable("preset", t_155);
}
if(frame.topLevel) {
context.addExport("preset", t_155);
}
if(runtime.memberLookup((l_tile),"faceOutImage")) {
var t_156;
t_156 = runtime.memberLookup((l_tile),"faceOutImage");
frame.set("imageStyle", t_156, true);
if(frame.topLevel) {
context.setVariable("imageStyle", t_156);
}
if(frame.topLevel) {
context.addExport("imageStyle", t_156);
}
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"images")) {
var t_157;
t_157 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"images")),0);
frame.set("imageStyle", t_157, true);
if(frame.topLevel) {
context.setVariable("imageStyle", t_157);
}
if(frame.topLevel) {
context.addExport("imageStyle", t_157);
}
;
}
else {
var t_158;
t_158 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"productTileImagePreset");
frame.set("preset", t_158, true);
if(frame.topLevel) {
context.setVariable("preset", t_158);
}
if(frame.topLevel) {
context.addExport("preset", t_158);
}
t_123 += "\n            ";
var t_159;
t_159 = runtime.contextOrFrameLookup(context, frame, "imageHeight");
frame.set("mtoImageHeight", t_159, true);
if(frame.topLevel) {
context.setVariable("mtoImageHeight", t_159);
}
if(frame.topLevel) {
context.addExport("mtoImageHeight", t_159);
}
t_123 += "\n            ";
var t_160;
t_160 = runtime.contextOrFrameLookup(context, frame, "imageWidth");
frame.set("mtoImageWidth", t_160, true);
if(frame.topLevel) {
context.setVariable("mtoImageWidth", t_160);
}
if(frame.topLevel) {
context.addExport("mtoImageWidth", t_160);
}
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish") && !runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"images")) {
var t_161;
t_161 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty")),"default")),"scene7")),"tile_placeholder_image_small");
frame.set("imageStyle", t_161, true);
if(frame.topLevel) {
context.setVariable("imageStyle", t_161);
}
if(frame.topLevel) {
context.addExport("imageStyle", t_161);
}
;
}
else {
var t_162;
t_162 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty")),"default")),"scene7")),"tile_placeholder_image_large");
frame.set("imageStyle", t_162, true);
if(frame.topLevel) {
context.setVariable("imageStyle", t_162);
}
if(frame.topLevel) {
context.addExport("imageStyle", t_162);
}
;
}
;
}
;
}
if(runtime.memberLookup((l_tile),"hoverImage")) {
l_altImageId = runtime.memberLookup((l_tile),"hoverImage");
frame.set("altImageId", l_altImageId, true);
if(frame.topLevel) {
context.setVariable("altImageId", l_altImageId);
}
if(frame.topLevel) {
context.addExport("altImageId", l_altImageId);
}
;
}
else {
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"images")) > 1) {
l_altImageId = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"images")),1);
frame.set("altImageId", l_altImageId, true);
if(frame.topLevel) {
context.setVariable("altImageId", l_altImageId);
}
if(frame.topLevel) {
context.addExport("altImageId", l_altImageId);
}
;
}
else {
l_altImageId = runtime.contextOrFrameLookup(context, frame, "imageStyle");
frame.set("altImageId", l_altImageId, true);
if(frame.topLevel) {
context.setVariable("altImageId", l_altImageId);
}
if(frame.topLevel) {
context.addExport("altImageId", l_altImageId);
}
;
}
;
}
var t_163;
t_163 = 523;
frame.set("mtoImageHeight", t_163, true);
if(frame.topLevel) {
context.setVariable("mtoImageHeight", t_163);
}
if(frame.topLevel) {
context.addExport("mtoImageHeight", t_163);
}
t_123 += "\n        ";
var t_164;
t_164 = 349;
frame.set("mtoImageWidth", t_164, true);
if(frame.topLevel) {
context.setVariable("mtoImageWidth", t_164);
}
if(frame.topLevel) {
context.addExport("mtoImageWidth", t_164);
}
t_123 += "\n\n        ";
t_123 += runtime.suppressValue((lineno = 485, colno = 20, runtime.callWrap(t_154, "mtoImage", context, [(lineno = 486, colno = 24, runtime.callWrap(t_5, "imageUrl", context, [])),runtime.contextOrFrameLookup(context, frame, "imageStyle"),runtime.makeKeywordArgs({"preset": runtime.contextOrFrameLookup(context, frame, "preset"),"altImageId": l_altImageId,"imageHeight": runtime.contextOrFrameLookup(context, frame, "mtoImageHeight"),"imageWidth": runtime.contextOrFrameLookup(context, frame, "mtoImageWidth"),"altText": runtime.contextOrFrameLookup(context, frame, "altText"),"class": "c-product-tile__img js-product-tile-img","disableZoom": true,"lazyImage": true,"lazyImageWidth": runtime.contextOrFrameLookup(context, frame, "mtoImageWidth"),"lazyImageHeight": runtime.contextOrFrameLookup(context, frame, "mtoImageHeight"),"lazy": runtime.contextOrFrameLookup(context, frame, "lazy"),"quality": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")})])), env.opts.autoescape);
})});
}
else {
t_123 += "\n        ";
var t_165;
t_165 = (runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"supplierSku")?runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"supplierSku"):runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"styleNumber"));
frame.set("imageStyle", t_165, true);
if(frame.topLevel) {
context.setVariable("imageStyle", t_165);
}
if(frame.topLevel) {
context.addExport("imageStyle", t_165);
}
t_123 += "\n\n        ";
var t_166;
t_166 = (runtime.contextOrFrameLookup(context, frame, "imagePreset")?runtime.contextOrFrameLookup(context, frame, "imagePreset"):runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"productTileImagePreset"));
frame.set("preset", t_166, true);
if(frame.topLevel) {
context.setVariable("preset", t_166);
}
if(frame.topLevel) {
context.addExport("preset", t_166);
}
t_123 += "\n\n        ";
var t_167;
t_167 = (function() {
var output = "";
t_123 += "\n            ";
t_123 += runtime.suppressValue((lineno = 511, colno = 25, runtime.callWrap(t_9, "productImage", context, [(lineno = 512, colno = 24, runtime.callWrap(t_5, "imageUrl", context, [])),runtime.contextOrFrameLookup(context, frame, "imageStyle"),runtime.contextOrFrameLookup(context, frame, "_safeColorCode"),runtime.contextOrFrameLookup(context, frame, "_safeImageId"),runtime.makeKeywordArgs({"altImageId": runtime.contextOrFrameLookup(context, frame, "_altImageId"),"preset": runtime.contextOrFrameLookup(context, frame, "preset"),"altText": runtime.contextOrFrameLookup(context, frame, "altText"),"class": "c-product-tile__img js-product-tile-img","disableZoom": true,"defaultImage": runtime.contextOrFrameLookup(context, frame, "defaultImage"),"lazyImage": true,"lazyImageWidth": 349,"lazyImageHeight": 523,"lazy": runtime.contextOrFrameLookup(context, frame, "lazy"),"quality": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")})])), env.opts.autoescape);
;
return output;
})()
;
frame.set("tileImage", t_167, true);
if(frame.topLevel) {
context.setVariable("tileImage", t_167);
}
if(frame.topLevel) {
context.addExport("tileImage", t_167);
}
t_123 += "\n\n        ";
if(runtime.memberLookup((l_tile),"hasTileVideo")) {
t_123 += runtime.suppressValue((lineno = 533, colno = 22, runtime.callWrap(t_13, "videoTile", context, [(lineno = 533, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_tile,"video"])),runtime.contextOrFrameLookup(context, frame, "tileImage"),runtime.memberLookup((runtime.memberLookup((l_tile),"product")),"productSlug"),runtime.memberLookup((l_tile),"shouldShowVideoOnHover")])), env.opts.autoescape);
t_123 += "\n        ";
;
}
else {
t_123 += "\n            ";
t_123 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "tileImage")), env.opts.autoescape);
t_123 += "\n        ";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_123);
});
context.setVariable("_displayTileImage", macro_t_122);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/product-tile-macro.j2"] , dependencies)